import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import { INITIAL_SCHEMA, INITIAL_CONFIG } from '@/helpers/dev';

export const dev = {
  namespaced: true,
  state: {
    schema: INITIAL_SCHEMA,
    initialSchema: INITIAL_SCHEMA,
    configLayout: INITIAL_CONFIG,
    environments: [],
    modes: [],
    pages: [],
    navItems: [],
    parents: [],
    currentTemplate: 'templateHome',
    typeOfPageEditing: '',
    selectedPage: '',
    selected: {},
    selectedItem: {},
    currentMode: null,
    selectedTab: null,
    selectedStep: null,
    activeTab: null,
    activeStep: null,
    selectedEnvironment: null,
    selectedPortal: null,
    selectedModule: null,
    selectedComponent: false,
    accordionType: null,
    sidebarTab: null,
    confirmPageChanges: {
      dialog: false,
      origin: '',
      fileName: '',
      redirect: ''
    }
  },
  getters,
  mutations,
  actions
};
